function loader() {
  return import(/*webpackChunkName:"platform_pc_button_handler"*/ "./~handler").then((res) => {
    let module = dsf.getEsModule(res);
    return module;
  });
}

//子表添加行防抖，点击过快会卡住浏览器
let addSubTableRow = _.debounce((table, row, firstRowInser) => {
  if (firstRowInser === true || firstRowInser === "true") {
    table.insertRow(row, 0, true);
  } else {
    table.pushRow(row, true);
  }
}, 100);

async function exec(fn, args) {
  const handler = await loader();
  return await handler[fn].call(this, args);
}

export default {
  //公共类 start
  //表单保存
  system_form_save(args) {
    return exec.call(this, "saveForm", args);
  },
  system_form_delete(args) {
    return exec.call(this, "deleteForm", args);
  },
  system_form_copy(args) {
    return exec.call(this, "copyForm", args);
  },
  system_form_data(args) {
    return exec.call(this, "getFormData", args);
  },
  //打开新窗口
  system_open_window(args) {
    return exec.call(this, "openWindow", args);
  },
  //关闭窗口（对话框）
  system_close_window(args) {
    args?._self?.$vm?.$closeWindow?.();
  },
  //弹出模态框
  system_pop_modal(args) {
    return exec.call(this, "openDialog", args);
  },
  //弹出抽屉
  system_open_drawer(args) {
    return exec.call(this, "openDrawer", args);
  },
  // 关闭模态框
  system_close_dialog(args) {
    this?.$dialog?.$parent?.close?.();
  },
  //接口调用
  system_interface_exec(args) {
    return exec.call(this, "execInterface", args);
  },
  // 模块下载
  system_template_download(args) {
    return exec.call(this, "datagridTemplateDownload", args);
  },
  //公共类 end

  //列表 start
  //清空筛选条件
  system_datagrid_clear_condition(args) {
    return exec.call(this, "datagridClearCondition", args);
  },
  //批量删除
  system_datagrid_batch_delete(args) {
    return exec.call(this, "datagridBatchDelete", args);
  },
  //列表行删除数据
  system_datagrid_delete(args) {
    return exec.call(this, "datagridDelete", args);
  },
  //列表导入(上传文件成功后执行该函数)
  system_datagrid_import(args) {
    return exec.call(this, "datagridImport", args);
  },
  //用户预导入
  system_user_import(args) {
    // console.log(1111)
    return exec.call(this, "userImport", args);
  },
  //列表行上传按钮
  system_datagrid_row_upload(args) {
    return exec.call(this, "datagridRowUpload", args);
  },
  //列表预导入(上传文件成功后执行该函数)
  system_datagrid_preimport(args) {
    return exec.call(this, "datagridPreImport", args);
  },
  //列通用预导入(上传文件成功后执行该函数)
  system_datagrid_common_import(args) {
    return exec.call(this, "datagridCommonImport", args);
  },
  //列表导出
  system_datagrid_export(args) {
    return exec.call(this, "datagridExport", args);
  },
  //触发列表检索
  system_datagrid_search(args) {
    const { owner } = args;
    owner?.$refs?.superSearchBar?.closeOrOpen?.(false);
    owner?.search?.();
  },
  //设置列显示
  system_datagrid_columns_filter(args) {
    return exec.call(this, "datagridColumnsFilter", args);
  },
  // 保存模板
  system_datagrid_template_save(args) {
    this.$openDialog({
      title: "保存模板",
      width: "700px",
      content: "DsfDataGridTemplateSave",
      params: {
        args: args
      }
    });
  },
  // 管理模板
  system_datagrid_template_manage(args) {
    this.$openDialog({
      title: "管理模板",
      width: "700px",
      content: "DsfDataGridTemplateManage",
      params: {
        args: args
      }
    });
  },

  //列表 end

  //子表 start
  // 子表插入行
  system_subtable_insert(args, $event) {
    let $table = args.owner;
    let firstRowInser = args.params[0];
    if (!$table.isUseDialogEdit) {
      let row = {};
      addSubTableRow($table, row, firstRowInser);
    } else {
      $table.openDialogEdit({
        isAddNew: true,
        firstRowInser: firstRowInser
      });
    }
    $event.stopPropagation();
  },
  // 子表清空
  system_subtable_clear(args) {
    dsf.layer
      .confirm("是否要清空当前所有行？")
      .then(() => {
        let value = args.owner.value;
        args.owner.clearRows();
        args.owner.$dispatch('clear-rows', [...value]);
      })
      .catch(() => {});
  },
  // 子表批量删除
  system_subtable_batch_delete(args) {
    let rows = args.owner.multipleSelection;
    if (!rows || !rows.length) {
      dsf.layer.message("请至少选中一行数据", false);
      return;
    }
    dsf.layer
      .confirm("是否要删除当前所选行？")
      .then(() => {
        args.owner.removeRows(rows);
        args.owner.$dispatch('remove-rows', [...rows]);
      })
      .catch(() => {});
  },
  // 子表选择
  system_subtable_datachoice(args) {
    return exec.call(this, "subtableDataChoice", args);
  },
  // 子表导入
  system_subtable_import(args) {
    return exec.call(this, "subtableImport", args);
  },
  // 子表导出
  system_subtable_export(args) {
    return exec.call(this, "subtableExport", args);
  },
  //子表粘贴excel数据
  system_subtable_paste_excel(args) {
    return exec.call(this, "subtablePasteExcel", args);
  },
  //子表行编辑
  system_subtable_row_edit(args) {
    let scope = args._self.slotScopeData;
    args.owner.rowEditHandler(scope);
  },
  //子表行删除
  system_subtable_row_delete(args) {
    let scope = args._self.slotScopeData;
    args.owner.rowDeleteHandler(scope);
  },
  //子表行上移
  system_subtable_row_up(args) {
    let scope = args._self.slotScopeData;
    args.owner.rowUpHandler(scope);
  },
  //子表行下移
  system_subtable_row_down(args) {
    let scope = args._self.slotScopeData;
    args.owner.rowDownHandler(scope);
  },
  //流程批量发送
  system_batch_flow_send(args) {
    import(/* webpackChunkName: "platform_pc_flowBatchSend" */ "./flowBatchSend").then((res) => {
      res.default(args);
    });
  },
  //弹出流程模态框
  system_flow_openDialog(args) {
    return exec.call(this, "flowOpenDialog", args);
  },
  system_navtree_delete(args) {
    return exec.call(this, "navTreeDelete", args);
  }
};
